import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

/**
 * Actions of a result widget, needed as it's used as a selector in the API.
 * @docs-private
 */
@Directive({
  standalone: false,
  selector: '[campusResultWidgetActions], campus-result-widget-actions',
})
export class ResultWidgetActionsDirective {
  @HostBinding('class.ui-result-widget__actions')
  isActionsClass = true;
}
/**
 * Content of a result widget, needed as it's used as a selector in the API.
 * @docs-private
 */
@Directive({
  standalone: false,
  selector: '[campusResultWidgetContent], campus-result-widget-content',
})
export class ResultWidgetContentDirective {
  @HostBinding('class.ui-result-widget__content')
  isContentClass = true;

  @HostBinding('attr.data-cy')
  cyAttribute = 'content';
}
/**
 * Label of a result widget, needed as it's used as a selector in the API.
 * @docs-private
 */
@Directive({
  standalone: false,
  selector: '[campusResultWidgetLabel], campus-result-widget-label',
})
export class ResultWidgetLabelDirective {
  @HostBinding('class.ui-result-widget__label')
  isLabelClass = true;
}

@Component({
  standalone: false,
  selector: 'campus-result-widget',
  templateUrl: './result-widget.component.html',
  styleUrls: ['./result-widget.component.scss'],
})
export class ResultWidgetComponent implements AfterViewInit {
  @HostBinding('class')
  defaultClasses = ['ui-result-widget', 'surface', 'border', 'border-2', 'border-stroke-variant', 'corner-m'];

  @Input() handleOverflow: boolean;

  @Output() clickExpandOverflow = new EventEmitter();

  @ViewChild('content', { read: ElementRef })
  content: ElementRef;

  chartOverflow = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit() {
    const contentEl = this.content.nativeElement;
    const barChartEl = contentEl.querySelector('.ui-bar-chart');
    if (this.handleOverflow && contentEl && barChartEl) {
      this.calculateOverflow(contentEl, barChartEl);
      this.cdRef.detectChanges();
    }
  }

  private calculateOverflow(contentEl, barchartEl) {
    // handling overflows only works for barcharts right now
    const barChartWidth = barchartEl.offsetWidth;
    const contentWidth = contentEl.clientWidth;
    this.chartOverflow = barChartWidth - contentWidth > 0;
  }
}
